import { timeoutDuration } from 'utils/constants/dateInfo/time-numbers';

const timers: Record<string, NodeJS.Timeout> = {};

export function debounce<T extends unknown[]>(
  debounceId: string,
  func: (...args: T) => void,
  timeout = timeoutDuration.DURATION_300
): (...args: T) => void {
  return (...args: T) => {
    clearTimeout(timers[debounceId]);
    timers[debounceId] = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}
